import React, { forwardRef } from 'react';

import { START_OF_DAY, END_OF_DAY } from '@vlabs/shared/config';
import { DateInput } from '@vlabs/uikit/components/controls/date-input/DateInput';
import { parseISO } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';

import st from './popovers.module.sass';
import { useUserListFilters } from '../useUserListPageFilters';

function DateCreatedFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { t } = useTranslation();
  const { filters, updateFilters } = useUserListFilters();

  return (
    <PopoverWithButton
      {...props}
      data-testid="create_time"
      onClickReset={() => updateFilters({
        create_time__gte: undefined,
        create_time__lt: undefined,
      })}
      ref={ref}
    >
      <div className={st.DateInputWrapper}>
        <DateInput
          enableTime
          id="create_time__gte"
          isClearable
          label={t('from_label') as unknown as string}
          name="create_time__gte"
          onChange={([create_time__gte]: Date[]) => updateFilters({
            create_time__gte: create_time__gte?.toISOString(),
          })}
          options={START_OF_DAY}
          value={filters.create_time__gte ? parseISO(filters.create_time__gte) : ''}
        />
      </div>
      <div className={st.DateInputWrapper}>
        <DateInput
          enableTime
          id="create_time__lt"
          isClearable
          label={t('to_label') as unknown as string}
          name="create_time__lt"
          onChange={([create_time__lt]: Date[]) => updateFilters({
            create_time__lt: create_time__lt?.toISOString(),
          })}
          options={END_OF_DAY}
          value={filters.create_time__lt ? parseISO(filters.create_time__lt) : ''}
        />
      </div>
    </PopoverWithButton>
  );
}

const DateCreatedFilterPopoverWithRef = forwardRef(DateCreatedFilterPopover);
export { DateCreatedFilterPopoverWithRef as DateCreatedFilterPopover };
